<div
  class="tree"
  cdkDropList
  [id]="idName ? idName : 'tree-node-drag'"
  [cdkDropListConnectedTo]="['list-1', 'list-2', 'create-edit-plan','start-execution-table', 'select-test-case']"
>
  <div
    cdkDrag
    [cdkDragData]="node"
    [cdkDragPreviewClass]="'hide-preview'"
    *ngFor="let node of nodes | sortByKey : 'order'; let i = index"
    [ngStyle]="node.style"
    [ngClass]="{
      'highlight-children': (selectedNode && selectedNode.id === node.id && !disableGroupHighlight) || (expandedNodes.has(node.id) && highlightOnExpand && !node.level),
      'default-class': !(selectedNode && selectedNode.id === node.id),
      'draggable': isEditor,
      'movable': draggable && node.level
    }"
    [hidden]="isSearch && !node.isSearchMatch"
  >
    <div
      [ngClass]="{
        'highlight-children': selectedNode && selectedNode.id === node.id && disableGroupHighlight,
        'disable-hover': node.disableHoverEffect,
        'mark-selected': selectedNode && selectedNode.id === node.id,
        'draggable': isEditor,
        'default-label': node.type === 'default-label',
        'level-0-node': node.level === 0,
        'level-1-node': node.level === 1,
        'remove-green-left-border': removeGreenLeftBorder,
        'removeBg': removeBg
      }"
      class="node"
      [ngStyle]="{
       'padding-left': ((node.level * 18) - (node.children ? 26 : 0)) + 'px',
       'cursor': draggable && node.level ? 'move' : '',
      }"
    >
      <div
        class="d-flex flex-grow-1"
        (click)="toggleExpand(node); $event.stopPropagation()"
        (keydown)="toggleExpand(node); $event.stopPropagation()"
      >
       <!-- Prefix Icon -->
       <div
       class="d-flex flex-column justify-content-center pe-2"
       *ngIf="node.prefixIcon && !hideIconForChildren"
     >
       <img
         [src]="getPrefixIcon(node)"
         (error) ="onImgError($event)"
         class="asset-icon"
         [alt]="node.prefixIcon"
       />
     </div>

        <!-- Expand Button -->
        @if((selectedNode && selectedNode.id === node.id) && isloading) {
        <span
          class="spinner-border spinner-border-sm mx-2"
          role="status"
          aria-hidden="true"
        ></span>
        } @else {
          <button *ngIf="node.children" class="expand-btn">
            <i [ngClass]="
                expandedNodes.has(node.id)
                  ? 'bi bi-chevron-down'
                  : 'bi bi-chevron-right'
              " [class]="node.level == 0 ? 'text-weight-bold':''"></i>
          </button>
        }

         <!-- Checkbox -->
        <div class="checkbox-container me-2" *ngIf="node.isCheckable">
          <input
            type="checkbox"
            class="form-check-input"
            [(ngModel)]="node.checked"
            (click)="onCheckboxChange(node, $event)"
            (keydown.enter)="onCheckboxChange(node, $event)"
          />
        </div>

        <!-- Asset Icon -->
        <div
          class="d-flex flex-column justify-content-center"
          *ngIf="node.assetIcon && !hideIconForChildren"
        >
          <img
            [src]="getAssetIcon(node)"
            (error) ="onImgError($event)"
            class="asset-icon"
            [alt]="node.assetIcon"
          />
        </div>

        <!-- Item Icon -->
        <app-icon
          *ngIf="node?.icon && !hideIconForChildren"
          [icon]="node?.icon ?? 'default-icon'"
          [customStyle]="{'font-size': '15px'}"
          [class]="node.level == 0 ? 'text-weight-bold':''"
          [isGoogleIcon]="true"
        ></app-icon>

        <!-- Display Name -->
        <div class="display-name-div justify-content-start">
          <div *ngIf="node.oprtationType" class="tag-label d-flex" [ngClass]="getOperationClass(node.oprtationType)">
            <span class="general-text-17 m-auto">
              {{node.oprtationType}}
            </span>
          </div>
          <!-- Hyperlink display name (e.g. execution report links) -->
          <a *ngIf="node.hyperlink"
            class="general-txt ellipsis tree-node-hyperlink"
            [ngStyle]="{width: (170-(node.level*13)) + 'px' }"
            [class]="node.level == 0 ? 'text-weight-bold level-0-text' : (node.level == 1 ? 'level-1-text' : '')"
            [ngClass]="{ 'sub-lable': node.type === 'default-label'}"
            [href]="node.hyperlink"
            target="_blank"
            rel="noopener noreferrer"
            [title]="node.displayName"
            (click)="$event.stopPropagation()">
            {{ node.displayName }}
          </a>
          <!-- Plain display name -->
          <span *ngIf="!node.hyperlink" class="general-txt ellipsis"
          [ngStyle]="{width: (170-(node.level*13)) + 'px' }"
          [class]="node.level == 0 ? 'text-weight-bold level-0-text' : (node.level == 1 ? 'level-1-text' : '')"
          [ngClass]="{ 'sub-lable': node.type === 'default-label'}"
          (click)="toggleExpand(node); $event.stopPropagation()" (keydown)="toggleExpand(node); $event.stopPropagation()" [title]="node.displayName">
            {{ node.displayName }}
          </span>
          <!-- Optional inline badge (e.g. "Default Version", "Active Version") -->
          <span
            *ngIf="node.badge"
            class="tree-node-badge"
            [class.tree-node-badge--active]="node.badge.variant === 'active'"
          >{{ node.badge.text }}</span>
        </div>
      </div>

        <!-- Action Icon -->
        <div
        class="d-flex flex-column justify-content-center"
        *ngIf="node.actionIcon && !hideIconForChildren"
      >
        <img
          [src]="getActionIcon(node)"
          (error) ="onImgError($event)"
          class="asset-icon"
          [alt]="node.actionIcon"
        />
      </div>

      <!-- Actionable Icons -->
      <div *ngIf="node.actionableIcons" class="d-flex icon-list">
        <div class="v-center mx-2" *ngFor="let item of node.actionableIcons">
          @if(item.isLoading) {
            <span
              class="spinner-border spinner-border-sm mx-2"
              role="status"
              aria-hidden="true"
              style="width: 16px;"
            ></span>
          } @else {
            @if(item.icon?.endsWith('.svg')) {
              <img
                [src]="'assets/images/virtusa-icons/' + item.icon"
                [alt]="item.key"
                class="actionable-icon"
                [ngClass]="item.className"
                style="width: 18px; height: 18px; cursor: pointer;"
                (click)="handleActionableItemAction(node, item)"
                (keydown.enter)="handleActionableItemAction(node, item)"
              />
            } @else {
              <app-icon
                [icon]="item.icon"
                [customStyle]="{'font-size': '18px'}"
                [isGoogleIcon]="true"
                class="actionable-icon"
                [ngClass]="item.className"
                (click)="handleActionableItemAction(node, item)"
                (keydown)="handleActionableItemAction(node, item)">
              </app-icon>
            }
          }
        </div>
      </div>
      
      <div class="context-items" *ngIf="node.menu || node.isAdd">
        <div class="icon-div">
          <img
            *ngIf="node?.isAdd"
            src="assets/images/virtusa-icons/add-icon.svg"
            alt="add"
            class="icon-img add-icon"
            (click)="openAddItemsPopup(node); $event.stopPropagation()"
            (keydown.enter)="openAddItemsPopup(node); $event.stopPropagation()"
          />
          <app-icon
            *ngIf="node?.menu"
            [icon]="'more_horiz'"
            [customStyle]="{'font-size': '15px'}"
            [isGoogleIcon]="true"
            (click)="toggleContextMenu($event, i); $event.stopPropagation()"
            (keydown.enter)="toggleContextMenu($any($event), i); $event.stopPropagation()"
          ></app-icon>
        </div>
        <ul
          class="context-menu-items"
          *ngIf="contextMenuIndex === i && node.menu"
          [ngStyle]="{
            top: contextMenuPosition.y + 'px',
            left: contextMenuPosition.x + 'px'
          }"
        >
          <li
            *ngFor="let item of node.menu"
            (click)="handleContextMenuAction(node, item)"
            (keydown)="handleContextMenuAction(node, item)"
          >
            <span class="header-12">
              {{ item }}
            </span>
          </li>
        </ul>
      </div>

      <div *ngIf="node?.isTickable" class="mx-2 tick-icon" [ngClass]="{'cursor-pointer': !disableNodeTick}" (click)="onTick(node)" (keydown)="onTick(node)">
        @if(node.isTicked) {
          <app-icon
            [icon]="'check_circle'"
            [isGoogleIcon]="true"
            [customStyle]="{'font-size': '20px'}"
            [isFilled]="true">
          </app-icon>
        } @else {
          <app-icon
            [icon]="'check_circle'"
            [isGoogleIcon]="true"
            [customStyle]="{'font-size': '20px', opacity: '0.4'}">
          </app-icon>
        }
      </div>

    </div>

    <!-- Recursive Child Tree -->
    <app-tree-view
      *ngIf="expandedNodes.has(node.id) && node.children?.length"
      [disableNodeSelect]="disableNodeSelect"
      [nodes]="node.children"
      [disableNodeTick]="disableNodeTick"
      [appendParentToSelectedNode]="appendParentToSelectedNode"
      [selectedNode]="selectedNode"
      [isloading]="isloading"
      (menuItemSelected)="onMenuItemSelected($event)"
      (actionableItem)="onActionableNodeClicked($event)"
      (onItemTick)="onChildTicked($event)"
      [disableGroupHighlight]="disableGroupHighlight"
      [highlightOnExpand]="highlightOnExpand"
      [removeGreenLeftBorder]="removeGreenLeftBorder"
      [removeBg]="removeBg"
      [isSearch]="isSearch"
      [isEditor]="isEditor"
      [draggable]="draggable"
      [hideIconForChildren]="hideIconForChildren"
      [singleExpandMode]="singleExpandMode"
    ></app-tree-view>
  </div>
  <!-- <app-no-data *ngIf="nodes.length==0"></app-no-data> -->
</div>
